import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { CartItemsList } from "./CartItemsList";
import { PaymentMethodSelector } from "./PaymentMethodSelector";
import { CartValidation } from "./CartValidation";
import { Switch } from "@/components/ui/switch";
import { CartContentProps } from "@/types/cart";
import { CreditSaleForm } from "./CreditSaleForm";

export const CartContent = ({
  digitalSignature,
  setDigitalSignature,
  cartItems,
  handleRemoveItem,
  isCredit,
  setIsCredit,
  partialPayment,
  setPartialPayment,
  paymentDueDate,
  setPaymentDueDate,
  customerName,
  setCustomerName,
  customerContact,
  setCustomerContact,
  customerAddress,
  setCustomerAddress,
  calculateTotal,
  onPaymentMethodChange,
  paymentMethod,
}: CartContentProps) => {
  return (
    <div className="space-y-6">
      <CartItemsList 
        cartItems={cartItems} 
        onRemoveItem={handleRemoveItem} 
      />

      <div className="flex items-center space-x-2">
        <Switch
          id="credit-sale"
          checked={isCredit}
          onCheckedChange={setIsCredit}
        />
        <Label htmlFor="credit-sale">Vente à crédit</Label>
      </div>

      {!isCredit && (
        <PaymentMethodSelector
          selectedMethod={paymentMethod}
          onMethodChange={onPaymentMethodChange}
        />
      )}

      <div className="space-y-2">
        <Label htmlFor="seller-signature">Signature du vendeur (obligatoire)</Label>
        <Textarea
          id="seller-signature"
          placeholder="Votre signature numérique"
          value={digitalSignature}
          onChange={(e) => setDigitalSignature(e.target.value)}
          className="h-20 resize-none"
        />
      </div>

      {isCredit && (
        <CreditSaleForm
          customerName={customerName}
          setCustomerName={setCustomerName}
          customerContact={customerContact}
          setCustomerContact={setCustomerContact}
          customerAddress={customerAddress}
          setCustomerAddress={setCustomerAddress}
          partialPayment={partialPayment}
          setPartialPayment={setPartialPayment}
          paymentDueDate={paymentDueDate}
          setPaymentDueDate={setPaymentDueDate}
          calculateTotal={calculateTotal}
          paymentMethod={paymentMethod}
          onPaymentMethodChange={onPaymentMethodChange}
        />
      )}

      <CartValidation />
    </div>
  );
};